import { Box } from '@mui/material';
import { useScenario } from '../../../../../../shared/contexts/ScenarioContext';
import { getScenarioHighlightColor } from '../../../../../../shared/utils/scenarioHighlight';

const ScenarioViewportRing = () => {
  const { activeScenario } = useScenario();

  if (!activeScenario) return null;

  return (
    <Box
      data-testid='scenario-viewport-ring'
      sx={{
        position: 'fixed',
        inset: 0,
        border: '4px solid',
        borderColor: (theme) => getScenarioHighlightColor(theme),
        boxShadow: (theme) =>
          `inset 0 0 16px 2px ${getScenarioHighlightColor(theme)}40`,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    />
  );
};

export default ScenarioViewportRing;
